<template>
  <van-swipe :autoplay="3000" indicator-color="white" class="home-banner">
    <van-swipe-item v-for="banner in list" :key="banner.id">
      <img :src="banner.url" :href="banner.tourl" alt="" />
    </van-swipe-item>
  </van-swipe>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="less">
.home-banner {
  height: 9rem;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
